module.exports = __webpack_public_path__ + "static/media/banner_7up7down-half.33135251.png";